import { parseSystemColumnFieldId } from '@doss/common-all'
import { GridSortItem, GridSortModel } from '@mui/x-data-grid-premium'
import { forEach } from 'lodash'
import {
  SortDirection,
  SystemGeneratedTableColumnType,
  TableSortInput,
  TableTabSortInput,
} from '~/common/generated/apollo-operations'
import { DetailedTableTab } from './types'

/**
 * Create input for update table tab sorts
 */
export function createUpdateTableTabSortsInput(sortModel: GridSortModel): TableTabSortInput[] {
  const createSortInputs: TableTabSortInput[] = []
  // Recreate all sorts from sortModel in the correct order
  forEach(sortModel, (sortItem) => {
    // Check if sortItem.field is a system-generated column type
    const systemGeneratedColumnType = parseSystemColumnFieldId(sortItem.field)
    if (systemGeneratedColumnType) {
      createSortInputs.push({
        direction: sortItem.sort === 'asc' ? SortDirection.ASC : SortDirection.DESC,
        systemGeneratedColumnType: systemGeneratedColumnType as SystemGeneratedTableColumnType,
      })
    } else {
      createSortInputs.push({
        direction: sortItem.sort === 'asc' ? SortDirection.ASC : SortDirection.DESC,
        tableColumnId: sortItem.field,
      })
    }
  })

  return createSortInputs
}

export function getSortsFromTableTab(selectedTab?: DetailedTableTab | null) {
  // Set the sorts to match what the selected tab has
  const cleanedSorts: TableSortInput[] = []
  const gridSortItems: GridSortItem[] = []

  forEach(selectedTab?.sorts, (sort) => {
    const columnId =
      sort.tableColumn?.id ??
      (sort as { systemGeneratedColumnType?: string }).systemGeneratedColumnType
    if (columnId == null) {
      return
    }
    cleanedSorts.push({
      columnId,
      direction: sort.direction,
    })
    gridSortItems.push({
      field: columnId,
      sort: sort.direction === SortDirection.ASC ? 'asc' : 'desc',
    })
  })

  return { cleanedSorts, gridSortItems }
}
